<template >
    <h1 class="game-version-code">{{gameVersion}}</h1>

    <EstablishTruths/>
    <PlayersComponent :isLastStand="isLastStand"  :players="5" />
  <CandlesComponent  :isLastStand="isLastStand" ref="CandleComponent"/>
  <DiceComponent :isLastStand="isLastStand" ref="DiceComponent"  :candles="this.candles"/>
    <img v-if="candles < 5 " class="border" src="Border.png" :style="{ opacity: isLastStand ? 0.5 : candles < 5 ? 0.35 - (candles/10): 0}"/>
    <div class="background-image"/>
        <WelcomeCard/>

</template>


<script>
import CandlesComponent from './components/CandlesComponent.vue'
import PlayersComponent from './components/PlayersComponent.vue'
import DiceComponent from './components/DiceComponent.vue'
import EstablishTruths from './components/EstablishTruths.vue'
import WelcomeCard from './components/WelcomeCard.vue';

import { useCandleStore } from './store/useCandleStore';
import { storeToRefs } from 'pinia'


export default {
  name: 'App',
  components: {
    PlayersComponent,
    CandlesComponent,
    DiceComponent,
    EstablishTruths,
    WelcomeCard,
  },

  setup(){
    const store = useCandleStore();
    const { candles, isLastStand, players, isTruthsTime, gameVersion } = storeToRefs(store);
    console.log("candles",candles)
    return {
      gameVersion,
      candles,
      isLastStand,
      players,
      isTruthsTime,
      store
    }
  },
  data(){
    return{
    rampingOpacity:[0.05,0.1,0.18,0.2]

    }
  },

  mounted(){
    let self = this;
    let currentCandle = 1;
    window.addEventListener('keyup', function(e) {
      if(e.code === "Digit"+currentCandle){
              currentCandle++;
              if(currentCandle >= 10) currentCandle = 0;
        self.outACandle()
      }
    })
  },
  methods: {
    getRemainingCandlesCount() {
      return 10;
    },
    outACandle(){
      if(this.isTruthsTime) return; 
      this.store.loseACandle();
      this.$refs.CandleComponent.outACandle(this.candles)
      this.$refs.DiceComponent.progressDarkness(this.candles)
      
      setTimeout(()=> {
        if(this.isLastStand && this.candles <= 0) this.isLastStand = false;
        this.isTruthsTime = true
        }, 1000);
    },

    reset(){
      //Will Reset Game State **ONLY IMPLEMENTABLE WITH A GLOBAL STATE MANAGER **
    }
  }
}
</script>

<style>

  @font-face {
  font-family: "SansCulottes";
  src: local("SansCulottes"),
  url(./assets/fonts/SansCulottes.ttf) format("truetype");
}

@font-face {
  font-family: "Eordeoghlakat";
  src: local("Eordeoghlakat"),
  url(./assets/fonts/Eordeoghlakat.ttf) format("truetype");
}

@font-face {
  font-family: "vtks distress";
  src: local("vtks distress"),
  url(./assets/fonts/vtks_distress.ttf) format("truetype");
}

html {
  overflow: auto;
}

#app {
  font-family: "Eordeoghlakat", "vtks distress", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  display: flex;
  height: 100vh;
  padding: 55px;
  align-items: stretch;
  flex-direction:column;
  row-gap: 15px;

  
}

.game-version-code {
  z-index: 5;
  position: absolute;
  top:10px;
  right:15px;
  color: white;
  font-size: 16pt;
  opacity: 0.1;
  font-family: serif;
}

.background-image {
  background-image: url("https://images.squarespace-cdn.com/content/v1/54cbdf08e4b0b8ab2e74ea9f/1612582240673-1SOTGMCWL93RVIPJCVDU/a3%28CMYK%29.jpg?format=1500w");
  position: absolute;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  z-index: -10;
  width: 100%;
  height: 100%;
  margin: -55px;
  opacity: 0.1;
  filter: saturate(0%) blur(2px);
}

body {
    background-color:rgb(7, 7, 7);
    justify-content: center;
    align-items: center;
    filter: brightness(100%);
  overflow-y: auto;

}

.border {
  position: absolute;
  width: 100%;
  height: 100%;
    margin: -55px;
    z-index: -5;

}

#app::-webkit-scrollbar{
  display: none;
}

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

    .notLastStand {
        background-color: rgb(7,7,7);
        color: white;
       border: 1px solid rgba(255, 255, 255, 0.205);
       box-shadow: 0 0 1px 1px rgba(255, 255, 255, 0.253);
    }

    .lastStand {
        background-color: rgb(7,7,7);
                color: white;

       border: 1px solid rgba(128, 0, 0, 0.575);
       box-shadow: 0 0 20px 5px rgba(128, 0, 0, 0.575);
       border-radius: 5px;
       
    }

    @keyframes candle-flicker {
  0% {
    opacity:100%;
  }
  20% {
    opacity:70%;
  }
   35% {
    opacity:65%;
  }
  53% {
    opacity:60%;
  }
 40% {
    opacity:70%;
  }
  80% {
    opacity:75%;
  }
  100% {
    opacity:100%;
  }
}
</style>
